module.exports = __webpack_public_path__ + "img/citic.720e4683.png";